/* =====================================================================
   modal-projeto-ar.js — Quiz "Proyectos Cocina" — Madesa ARGENTINA

   Derivado do modal-projeto.js (loja BR). Mesma arquitetura de envio:
   POST direto na HubSpot Forms Submission API v3 (lendo o cookie
   hubspotutk pra preservar atribuição), + upload de arquivo via form
   dedicado no endpoint v2 legado (<form>+<iframe> ocultos).

   DIFERENÇAS EM RELAÇÃO AO BR
   ---------------------------
   • 8 etapas em vez de 11. REMOVIDAS: eletrodomésticos, pia/bancada de
     mármore e profundidade da bancada. Sem saltos condicionais.
   • Renumeração: BR step9 -> AR step6, BR step10 -> AR step7,
     BR step11 -> AR step8.
   • Telefone com DDI +54 (Argentina) e sem máscara rígida — ver
     comentário em formatArgentinaPhone().
   • Slugs do DOM em espanhol (lineal / esquinera / paralela / en-u...).

   =====================================================================
   ⚠ MUDANÇA (set/2026) — BLOQUEIO DE REENVIO REMOVIDO

   Até esta versão, quem concluísse o quiz ficava TRAVADO na tela de
   agradecimento por 30 dias: uma marca em localStorage
   ("modal-projeto-ar-completed") fazia o modal reabrir direto no
   agradecimento, impedia a seta de voltar e barrava um segundo
   submitForm(). Por decisão do time, a AR passa a se comportar como o
   México: REENVIO LIBERADO.

   O que saiu (e onde estava):
     • COMPLETED_KEY / COMPLETED_TTL_MS      (constantes de storage)
     • markCompleted() / isCompleted()       (funções)
     • openModal()   — desvio que abria direto no agradecimento
     • goBack()      — trava na seta de voltar depois de concluir
     • recordExit()  — guarda que ignorava desistência pós-conclusão
     • submitForm()  — guarda de 2º envio + chamada markCompleted()

   CONSEQUÊNCIAS ACEITAS (são o comportamento pedido, não bugs):
     1. A mesma pessoa pode percorrer e enviar o quiz quantas vezes
        quiser. Cada volta gera UM envio novo no form 517d4924 e, com a
        captação antecipada ligada, mais um envio na etapa 1 — ou seja,
        até 2 envios por volta completa na timeline do contato.
     2. Da tela de agradecimento, a seta de voltar retorna à etapa 8
        (presupuesto) e permite enviar de novo na hora.
     3. A chave "modal-projeto-ar-completed" pode ter sobrado no
        localStorage de quem concluiu antes desta versão. Nada mais lê
        essa chave: é dado morto e não afeta o quiz.
   O progresso parcial (STORAGE_KEY, 7 dias) continua igual: quem
   abandona no meio retoma de onde parou; quem conclui tem o progresso
   limpo e começa do zero na próxima vez.

   =====================================================================
   ⚠ MUDANÇA (set/2026) — REDIRECT PARA A PÁGINA DE GRACIAS

   Pedido da Mídia, para medir conversão de lead numa URL própria. Mesma
   metodologia já aplicada no Quiz NEO (ar-madesa-neo-quiz.js).

   Quando redireciona para THANKYOU_URL:
     • ao CONCLUIR o quiz (depois do 200 da Forms API);
     • ao clicar "Continuar después" no card de confirmação de saída;
     • no botão "Cerrar" da tela de agradecimento (já era assim).

   Quando NÃO redireciona:
     • fechar (X ou ESC) nas etapas 0 e 1 — ali ainda não existe lead
       nenhum, e mandar essa pessoa pra página de gracias contaria uma
       conversão que não aconteceu. Controlado por
       REDIRECT_ON_CLOSE_MIN_QI;
     • "Saltar esta pregunta" (a pessoa continua no quiz).

   Três cuidados que fazem o redirect NÃO perder dado:
     • a captação antecipada e o registro de desistência passaram a usar
       `keepalive: true` — assim o POST sobrevive à navegação;
     • na conclusão, o redirect ESPERA o upload dos anexos (form+iframe)
       responder: navegar com o POST em voo CANCELA o upload;
     • a tela de agradecimento fica visível por um tempo mínimo, o que
       também dá folga para as tags de conversão (GA4/Meta) dispararem.

   ⚠ DIFERENÇA IMPORTANTE EM RELAÇÃO AO NEO: o quiz NEO só existe na LP
   da linha Neo, mas ESTE quiz abre em QUALQUER página da loja (home,
   coleção, produto). Ou seja, quem abre o quiz numa página de produto e
   clica "Continuar después" na etapa 4 é TIRADO daquela página e levado
   pra gracias. É o comportamento pedido, mas se a Mídia só precisar
   medir conclusão, ponha REDIRECT_ON_EXIT_ENABLED = false e o abandono
   volta a só fechar o modal, sem sair da página.

   =====================================================================
   CONFIGURAÇÃO HUBSPOT — estado atual

   JÁ CONFIRMADO:
     • FORM_ID principal  517d4924-e0e7-47ce-bf38-c9277580593a
     • FILE_FORM_ID       da601bc1-c90a-4cd7-bb5c-f79a1eb94c76
     • FILE_FIELD         arquivos_cozinha (propriedade tipo arquivo)
     • FIELD_MAP e VALUE_MAP das 7 perguntas
     • nacionalidade = "Argentina"
     • origem: mesmos rótulos do Brasil (quem separa o mercado é a
       propriedade `nacionalidade`, não a origem)

   AINDA A VALIDAR ANTES DO PRIMEIRO TESTE (procure por "TODO-AR"):
     1. `madesa_email_consent` está ADICIONADO COMO CAMPO neste form?
        (não basta a propriedade existir no CRM)
     2. `etapa_de_desistencia`: confirmar o internal name e cadastrar as
        opções `formato`, `medidas`, `linea`, `color`, `espacio-listo`,
        `fecha-compra`, `presupuesto`.
     3. Todos os campos enviados adicionados ao form, e form PUBLICADO
        (alteração não publicada mantém a definição antiga ativa p/ a API).
     4. Workflow que copia *_staging -> propriedade original com a ação
        "adicionar valor" (nunca "definir"), escopado a ESTE formulário.
     5. Tracking code da HubSpot no theme.liquid da loja AR — sem ele não
        existe cookie hubspotutk e a atribuição se perde.

   Lembretes que valem sempre:
     • A Forms API DESCARTA EM SILÊNCIO (status 200) campo cujo internal
       name não exista naquele form, e REJEITA valor de enum que não bata
       caractere por caractere.
     • Um POST 200 não garante que o campo foi gravado: confira o contato
       na HubSpot campo por campo depois de concluir o quiz inteiro.
   ===================================================================== */
(function () {
	const win = /** @type {any} */ (window);
	if (win.__modalProjetoArInitialized) return;
	win.__modalProjetoArInitialized = true;

	// -------------------------------------------------------------------
	// CONFIG HUBSPOT
	// -------------------------------------------------------------------
	const PORTAL_ID = "39596724";                 // portal Madesa (região na1)
	// "CRM-Formulário LP - Projetos Cozinha ARGENTINA" (publicado).
	// ⚠ Este GUID veio da ficha do formulário. Se algum envio voltar 404,
	// confira o data-form-id do snippet de EMBED (Compartilhar → Incorporar):
	// é ESSE que o endpoint de submissão usa.
	const FORM_ID = "517d4924-e0e7-47ce-bf38-c9277580593a";
	const SUBMIT_URL = "https://api.hsforms.com/submissions/v3/integration/submit/" + PORTAL_ID + "/" + FORM_ID;

	// Upload de arquivo (etapa 3) — form DEDICADO só com e-mail + campo de arquivo.
	// Motivo: a API v3 (JSON) não aceita binário; só o endpoint v2 legado aceita,
	// e usar o form principal pra isso inflaria a contagem de conversão dele.
	// GUID confirmado pelo data-form-id do snippet de embed.
	const FILE_FORM_ID = "da601bc1-c90a-4cd7-bb5c-f79a1eb94c76";
	// Propriedade do tipo ARQUIVO. UM único campo recebe TODOS os anexos:
	// eles vão juntos num só <input type="file" multiple>, numa só submissão.
	// NÃO crie um campo por arquivo nem faça um POST por arquivo.
	const FILE_FIELD = "arquivos_cozinha";
	const LEGACY_FILE_UPLOAD_URL = "https://forms.hubspot.com/uploads/form/v2/" + PORTAL_ID + "/" + FILE_FORM_ID;

	// -------------------------------------------------------------------
	// REDIRECT PÓS-QUIZ (Mídia: validação de conversão) — ver cabeçalho
	// -------------------------------------------------------------------
	// Para onde o usuário vai ao CONCLUIR o quiz, ao SAIR pelo card de
	// confirmação e pelo botão "Cerrar" da tela de agradecimento.
	// ⚠ Mantenha no MESMO domínio da loja: um salto entre domínios reinicia a
	// sessão do GA4 e não leva o cookie hubspotutk — justamente a atribuição
	// que essa página existe para medir.
	const THANKYOU_URL = "https://madesa.ar/pages/diseno-cocina-gracias";

	// Quanto tempo a tela de agradecimento fica visível antes de navegar (ms).
	// Também é a folga para as tags de conversão (GA4/Meta) dispararem.
	const SUCCESS_REDIRECT_DELAY_MS = 1500;

	// Teto de espera pelo upload dos anexos antes de navegar (ms). Navegar com
	// o POST do iframe em andamento CANCELA o upload, então o redirect espera o
	// iframe responder — ou este teto, o que acontecer primeiro.
	const FILE_UPLOAD_WAIT_MS = 12000;

	// "Continuar después" também leva pra página de gracias.
	// ⚠ Este quiz abre em QUALQUER página da loja (ver cabeçalho): com true,
	// quem desiste numa página de produto é tirado dela. Ponha false para
	// redirecionar somente na conclusão.
	const REDIRECT_ON_EXIT_ENABLED = true;

	// A partir de qual etapa FECHAR o modal (X / ESC) também redireciona:
	//   2 = só quando o lead já existe na HubSpot (a captação antecipada roda
	//       ao avançar da etapa 1). Etapas 0 e 1 fecham sem redirecionar.
	//   0 = redireciona em QUALQUER fechamento, inclusive na tela inicial.
	// (Nas etapas 2 a 8 o X nem fecha direto: abre o card de confirmação.)
	const REDIRECT_ON_CLOSE_MIN_QI = 2;

	// Trava de navegação única: impede que dois caminhos (redirect agendado
	// pela conclusão + clique em "Cerrar") disparem location duas vezes.
	let redirecting = false;
	let redirectTimer = null;

	/**
	 * @param {number} [delayMs] espera antes de navegar
	 * @param {boolean} [force] antecipa um redirect já agendado
	 */
	function goToThankYou(delayMs, force) {
		if (redirecting && !force) return;
		if (force && redirectTimer) window.clearTimeout(redirectTimer);
		redirecting = true;
		redirectTimer = window.setTimeout(() => {
			window.location.href = THANKYOU_URL;
		}, delayMs || 0);
	}

	// Telefone Argentina. O DDI vai concatenado aos dígitos nacionais.
	// PHONE_MOBILE_9: a Argentina usa o "9" depois do DDI para celulares em
	// formato internacional (54 9 11 1234-5678) — é o que o WhatsApp espera.
	// Se o time preferir gravar sem o 9, basta trocar para "" aqui.
	//
	// ⚠ FORMATO GRAVADO (set/2026): SÓ DÍGITOS, sem "+", sem espaço, sem
	// parênteses e sem hífen -> "5491111111111". O "+" foi removido porque a
	// HubSpot, ao reconhecer um número em formato internacional, aplica a
	// formatação local automática da propriedade de telefone (foi de onde
	// saíram o "(9)" e o hífen que apareciam no CRM — o script nunca enviou
	// esses caracteres). Sem o "+", o valor entra como o México já faz.
	// Essa formatação automática da HubSpot NÃO tem chave global para
	// desligar: se ela voltar a aparecer, a saída é no CRM (regra de
	// validação/propriedade), não neste arquivo.
	const PHONE_DDI = "54";
	const PHONE_MOBILE_9 = "9";

	// Campo de data (etapa 7). Na HubSpot é propriedade do tipo DATA
	// (seletor DD/MM/AAAA), então vai como epoch ms UTC — nunca como string.
	const DATE_FIELD = "cuando_quieres_realizar_la_compra_de_tu_cocina_";

	// ⚠ "Otro formato" NÃO existe no enum da propriedade
	// selecciona_el_formato_de_tu_nueva_cocina (as opções ativas são só
	// Cocina Lineal / Esquinera / Paralela / en U). Enviar um valor fora do
	// enum faz a HubSpot rejeitar a submissão inteira — o lead se perderia.
	// Por isso, enquanto a opção não for criada na HubSpot, quem escolher
	// "Otro formato" avança normalmente mas NÃO envia esse campo.
	// Para ativar: crie a opção "Otro formato" na propriedade, publique o
	// formulário e troque esta constante para true.
	const FORMATO_OTRO_ENABLED = false;

	// Mapa: chave interna do formData -> internal name da propriedade HubSpot.
	// Os nomes abaixo vieram da ficha do formulário AR (517d4924).
	// ⚠ O prefixo "0-1/" que aparece no DOM do form NÃO faz parte do internal
	// name real; e a HubSpot acrescenta sufixo (_1) quando há colisão de nome.
	const FIELD_MAP = {
		nome: "firstname",
		email: "email",
		telefone: "phone",
		formato: "selecciona_el_formato_de_tu_nueva_cocina",
		linha: "ar_cual_de_nuestras_lineas_le_gusto_mas",
		color: "que_color_prefiere_usted_",
		espacio: "el_espacio_ya_esta_listo_para_recibir_los_muebles_ar",
		presupuesto: "ar_cual_es_tu_presupuesto_para_una_cocina_nueva",
		data_compra: DATE_FIELD,
		// Texto de linha única -> recebe as paredes combinadas
		// ("Pared 1: 300cm, Pared 2: 250cm").
		medidasTexto: "cual_es_la_medida_de_tu_formato",
		// "" = não existe campo pra isso neste form; push() ignora nome vazio.
		gclid: "",
		sku: ""
	};

	// Mapa de VALORES: slug do DOM -> rótulo EXATO da opção na HubSpot.
	// ⚠ Bate caractere por caractere: acento, cifrão, espaço e ponto final
	// importam. Todos os rótulos abaixo foram copiados das opções ativas.
	const VALUE_MAP = {
		formato: {
			"lineal": "Cocina Lineal",
			"esquinera": "Cocina Esquinera",
			"paralela": "Cocina Paralela",
			"en-u": "Cocina en U",
			// Só é enviado se FORMATO_OTRO_ENABLED === true (ver acima).
			"otro": FORMATO_OTRO_ENABLED ? "Otro formato" : ""
		},
		// ⚠ As opções desta propriedade INCLUEM a faixa de preço no rótulo.
		// "Lux" sozinho não bate com "Lux $$$$$" e seria rejeitado.
		linha: {
			"lux": "Lux $$$$$",
			"vik": "Vik $$$$",
			"agata": "Agata $$$",
			"glamy": "Glamy $$$",
			"stella": "Stella $$$",
			"acordes": "Acordes $$$",
			"nice": "Nice $$",
			"reims": "Reims $"
		},
		color: {
			"gris": "Gris", "negro": "Negro", "blanco": "Blanco", "crema": "Crema",
			"marron": "Marrón", "verde": "Verde", "azul": "Azul"
		},
		espacio: {
			"si": "Sí",
			"no-en-obra": "No. Todavía está en obra/planificación",
			"no-con-fecha": "No. Pero ya tengo una idea de cuándo va a estar listo"
		},
		presupuesto: {
			"menos-1m": "Menos de $1.000.000",
			"1m-2m": "$1.000.000 a $2.000.000",
			"2m-3.5m": "$2.000.000 a $3.500.000",
			// ⚠ ATENÇÃO: a opção cadastrada na HubSpot está em PORTUGUÊS
			// ("Mais de $3.500.000"). A tela mostra "Más" (espanhol correto),
			// mas o valor enviado precisa ser idêntico ao do enum, senão é
			// rejeitado. Se você corrigir para "Más" na HubSpot, corrija AQUI
			// também — os dois têm que mudar juntos.
			"mas-3.5m": "Mais de $3.500.000"
		}
	};

	// Campos ocultos fixos, enviados em TODA submissão.
	// `nacionalidade` identifica o país da loja — obrigatório em todo
	// formulário Madesa, porque o mesmo portal atende BR/MX/AR e é isso que
	// separa os leads por mercado. Aqui é sempre "Argentina".
	// ⚠ Se a propriedade for de opção fixa, confirme que "Argentina" está
	// cadastrada como opção ativa: valor fora do enum pode fazer a API
	// rejeitar a submissão inteira.
	// ⚠ `fuente_de_registro__mexico_`: o internal name diz "mexico", mas a
	// propriedade é usada também pela Argentina (nasceu no projeto do México e
	// o nome ficou). Não tente "corrigir" para uma variante AR — o internal
	// name tem que ser exatamente este, senão o campo é descartado em silêncio.
	const HIDDEN_FIELDS = [
		{ name: "nacionalidade", value: "Argentina" },
		{ name: "fuente_de_registro__mexico_", value: "Quiz Proyectos" },
		{ name: "madesa_email_consent", value: "true" },
	];

	// Origem de cadastro (staging). NÃO fica em HIDDEN_FIELDS de propósito:
	// o workflow da HubSpot copia *_staging -> propriedade original com
	// "ADICIONAR valor". Se a origem fosse enviada na captação antecipada E
	// de novo na desistência, o contato acabaria com as duas origens somadas.
	// Por isso a origem é enviada UMA vez por sessão:
	//   • concluiu o quiz  -> origem normal, no submitForm()
	//   • desistiu no meio -> só a origem de desistente, no recordExit()
	//
	// ⚠ Os rótulos são DELIBERADAMENTE os mesmos do Brasil. Quem separa os
	// mercados é a propriedade `nacionalidade` (ver HIDDEN_FIELDS), não a
	// origem. Não crie variantes "AR" destes valores: isso fragmentaria os
	// relatórios de origem entre países sem necessidade.
	const ORIGIN_STAGING_NORMAL = [
		{ name: "origem_de_cadastro_staging", value: "LP Cozinhas (Quiz)" },
		{ name: "origem_de_cadastro__crm__staging", value: "LP (Quiz)" },
	];
	const ORIGIN_DESISTENTE = "LP (Quiz) Desistentes";

	// Consentimento. Se a API reclamar de legalConsentOptions, remover o bloco
	// é aceitável (os forms do portal usam processingConsentType: IMPLICIT).
	const LEGAL_CONSENT = {
		consent: {
			consentToProcess: true,
			text: "Para brindarte el servicio, necesitamos tu autorización para almacenar y procesar tus datos personales.",
			communications: [
				{ value: true, subscriptionTypeId: 2924505825, text: "Acepto recibir comunicaciones de Madesa." }
			]
		}
	};

	// Blindagem: este script NUNCA envia as propriedades REAIS de origem —
	// nem no envio normal, nem na desistência. Só as versões *_staging. Quem
	// atualiza as originais é o workflow da HubSpot.
	const NEVER_SEND_DIRECTLY = [
		"origem_de_cadastro",
		"origem_de_cadastro__crm_",
	];

	// Propriedade que registra em que etapa a pessoa desistiu.
	const EXIT_FIELD = "etapa_de_desistencia";

	// ⚠ PONTO DE ATENÇÃO — CAUSA MAIS PROVÁVEL DE "a etapa de desistência não
	// salva". A propriedade `etapa_de_desistencia` é ÚNICA no portal: a mesma
	// que o quiz do Brasil usa. Se o enum dela só tiver as opções em português,
	// os slugs em espanhol abaixo são DESCARTADOS EM SILÊNCIO pela Forms API
	// (status 200, campo vazio no contato) — nenhum erro aparece em lugar nenhum.
	//
	// COMO RESOLVER, escolha um dos dois:
	//   a) Cadastrar as opções em espanhol na propriedade e manter "es" aqui.
	//   b) Trocar a linha abaixo para "pt" e reutilizar as opções que já existem.
	//
	// Depois de concluir um teste desistindo no meio, confira no console:
	// o log "[modal-projeto-ar] DESISTÊNCIA →" mostra o valor exato enviado.
	// Se ele não aparecer no contato, é enum/campo — não é o código.
	const EXIT_STEP_LOCALE = "es";   // "es" | "pt"

	// data-step -> slug EXATO cadastrado no enum da propriedade.
	// Equivalência AR -> BR (o AR não tem eletrodomésticos/mármore/profundidade):
	//   AR 6 (espacio listo) = BR 9 · AR 7 (fecha compra) = BR 10 · AR 8 = BR 11
	const EXIT_STEP_BY_LOCALE = {
		es: {
			2: "formato",
			3: "medidas",
			4: "linea",
			5: "color",
			6: "espacio-listo",
			7: "fecha-compra",
			8: "presupuesto",
		},
		pt: {
			2: "formato",
			3: "medidas",
			4: "linha",
			5: "cor-frente",
			6: "espaco-pronto",
			7: "data-compra",
			8: "orcamento",
		},
	};
	const EXIT_STEP = EXIT_STEP_BY_LOCALE[EXIT_STEP_LOCALE] || EXIT_STEP_BY_LOCALE.es;

	// Opção 16 da propriedade. Quem CONCLUI o quiz recebe esta marca no mesmo
	// campo, sobrescrevendo qualquer etapa de desistência registrada antes —
	// assim uma propriedade só responde "onde parou / ou terminou".
	//
	// ⚠ O valor tem que ser o NOME INTERNO da opção, não o rótulo. Na propriedade
	// o rótulo é "Concluido" (sem acento) e o nome interno é "Concluído" (COM
	// acento) — é o nome interno que a Forms API compara, caractere por
	// caractere. Se no teste o campo não mudar para Concluído, a primeira coisa
	// a checar é justamente o acento aqui.
	const SEND_COMPLETED_EXIT_STEP = true;
	const EXIT_STEP_COMPLETED = "Concluído";

	function getHutk() {
		var m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
		return m ? m[2] : "";
	}

	// gclid: captura da URL e persiste na sessão.
	(function () {
		try {
			const params = new URLSearchParams(window.location.search);
			const gclid = params.get("gclid");
			if (gclid) {
				sessionStorage.setItem("__gclid_ar", gclid);
				win.__gclidAr = gclid;
			} else {
				win.__gclidAr = sessionStorage.getItem("__gclid_ar") || "";
			}
		} catch (e) {
			win.__gclidAr = "";
		}
	})();

	/** @param {string} eventName @param {Record<string, unknown>} [params] */
	function trackProjetoEvent(eventName, params) {
		try {
			if (typeof win.trackEvent === "function") {
				win.trackEvent(eventName, params && typeof params === "object" ? params : {});
			}
		} catch (e) {
			/* noop */
		}

		if (eventName === "contato_proyecto_ar") {
			win.dataLayer = win.dataLayer || [];
			win.dataLayer.push({
				event: "lead_proyecto_ar",
				email: (formData.email || "").trim().toLowerCase(),
				phone_number: (formData.telefone || "").trim(),
				first_name: (formData.nome || "").trim(),
				gclid: win.__gclidAr || ""
			});
		}
	}

	/** @type {Record<number, string>} */
	const MODAL_STEP_ADVANCE_EVENTS = {
		1: "contato_proyecto_ar",
		2: "formato_cocina_modal",
		3: "medidas_modal",
		4: "linea_cocina_modal",
		5: "color_cocina_modal",
		6: "espacio_listo_modal",
		7: "periodo_modal",
	};

	const modalOverlay = document.getElementById("modal-projeto-ar");
	const modalBackBtn = document.getElementById("modal-ar-back-btn");
	const modalCloseBtn = document.getElementById("modal-ar-close-btn");
	const modalConfirmOverlay = document.getElementById("modal-ar-confirm-exit");
	const modalConfirmTitle = document.getElementById("modal-ar-confirm-title");
	const modalConfirmMessage = document.getElementById("modal-ar-confirm-message");
	const modalConfirmStayBtn = document.getElementById("modal-ar-confirm-stay-btn");
	const modalConfirmSkipBtn = document.getElementById("modal-ar-confirm-skip-btn");
	const modalConfirmLeaveBtn = document.getElementById("modal-ar-confirm-leave-btn");
	const modalSuccessCloseBtn = document.getElementById("modal-ar-success-close-btn");
	if (!modalOverlay || !modalBackBtn || !modalCloseBtn) {
		return;
	}

	/** @type {Record<string, any>} */
	let i18n = {};
	const i18nScript = document.getElementById("modal-projeto-ar-i18n");
	if (i18nScript && i18nScript.textContent) {
		try {
			i18n = JSON.parse(i18nScript.textContent.trim());
		} catch (e) {
			console.error("[modal-projeto-ar] Bloco de i18n com JSON inválido — usando textos padrão.", e);
			i18n = {};
		}
	}

	const modal = modalOverlay;
	const backBtn = modalBackBtn;
	const closeBtn = modalCloseBtn;
	const MAX_FILE_MB = 100;                       // limite documentado da HubSpot
	const MAX_FILE_SIZE_BYTES = MAX_FILE_MB * 1024 * 1024;
	// Progresso parcial (para retomar o quiz de onde parou).
	// EM localStorage (antes era sessionStorage): o sessionStorage morre
	// quando a aba fecha, então quem desistia e voltava no dia seguinte
	// encontrava o formulário em branco.
	const STORAGE_KEY = "modal-projeto-ar-progress";
	const PROGRESS_TTL_MS = 7 * 24 * 60 * 60 * 1000;    // 7 dias
	// ⚠ REENVIO LIBERADO (set/2026): não existe mais marca de conclusão.
	// COMPLETED_KEY, COMPLETED_TTL_MS, markCompleted() e isCompleted() foram
	// removidos — ver o bloco de mudança no cabeçalho do arquivo. A chave
	// "modal-projeto-ar-completed" que sobrou no navegador de quem concluiu
	// antes desta versão não é lida por ninguém.

	// Captação antecipada do lead ao concluir a etapa 1.
	// ⚠ Ela é MUITO útil (garante o contato mesmo se a pessoa abandonar), mas
	// custa UMA submissão extra no formulário da HubSpot: um lead que conclui o
	// quiz aparece com 2 envios (captação + conclusão). Se o time preferir 1
	// envio por lead e aceitar perder quem abandona antes do fim, troque para
	// false — nada mais no arquivo precisa mudar.
	const EARLY_LEAD_CAPTURE_ENABLED = true;

	let isSubmitting = false;
	let leadCaptured = false;
	let openerProductId = "";
	// Última etapa já registrada como desistência nesta jornada. Evita POST
	// repetido quando a pessoa abre/fecha o modal várias vezes na mesma etapa.
	let lastExitStepRecorded = "";

	/** @type {number} */
	let currentStep = 0;
	const totalSteps = typeof i18n.totalSteps === "number" && i18n.totalSteps > 0 ? i18n.totalSteps : 8;

	// -------------------------------------------------------------------
	// PROGRESSO SALVO (localStorage, com fallback)
	// -------------------------------------------------------------------
	// Acesso a storage à prova de navegador em modo restrito (Safari privado,
	// cookies bloqueados). Tenta localStorage, cai pro sessionStorage, e se os
	// dois falharem o quiz segue funcionando — só sem memória entre visitas.
	const store = {
		get(key) {
			try { return window.localStorage.getItem(key); } catch (e) { /* segue */ }
			try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
		},
		set(key, value) {
			try { window.localStorage.setItem(key, value); return; } catch (e) { /* segue */ }
			try { window.sessionStorage.setItem(key, value); } catch (e) { /* desiste em silêncio */ }
		},
		remove(key) {
			try { window.localStorage.removeItem(key); } catch (e) { /* segue */ }
			try { window.sessionStorage.removeItem(key); } catch (e) { /* noop */ }
		},
	};

	function saveProgress() {
		try {
			store.set(STORAGE_KEY, JSON.stringify({
				step: currentStep,
				formData: formData,
				productId: openerProductId,
				// Persistidos para não repetir POSTs desnecessários ao reabrir.
				leadCaptured: leadCaptured,
				lastExitStep: lastExitStepRecorded,
				timestamp: Date.now()
			}));
		} catch (e) {
			console.error("[modal-projeto-ar] Falha ao salvar progresso:", e);
		}
	}

	function loadProgress() {
		try {
			const saved = store.get(STORAGE_KEY);
			if (!saved) return null;
			const progress = JSON.parse(saved);
			if (Date.now() - progress.timestamp > PROGRESS_TTL_MS) {
				store.remove(STORAGE_KEY);
				return null;
			}
			return progress;
		} catch (e) {
			console.error("[modal-projeto-ar] Falha ao ler progresso:", e);
			return null;
		}
	}

	function clearProgress() {
		try {
			store.remove(STORAGE_KEY);
		} catch (e) {
			console.error("[modal-projeto-ar] Falha ao limpar progresso:", e);
		}
	}

	// -------------------------------------------------------------------
	// CARD DE CONFIRMAÇÃO DE SAÍDA
	// -------------------------------------------------------------------
	// Textos embutidos como fallback: se o bloco de i18n sumir ou o JSON
	// quebrar, o card continua abrindo normalmente. O i18n tem prioridade.
	const CONFIRM_EXIT_DEFAULTS = {
		2: { title: "Este paso ayuda a dar forma a la cocina de tus sueños", message: "Elegir el formato de la cocina es clave para mostrarte opciones que funcionen en tu espacio.", stay: "Quiero elegir un formato", skip: "Saltar esta pregunta", leave: "Continuar después" },
		3: { title: "¿No tenés las medidas o una foto del espacio?", message: "Si todavía no las tenés a mano, podés continuar ahora y enviárnoslas después.", stay: "Quiero cargar las medidas", skip: "Saltar esta pregunta", leave: "Continuar después" },
		4: { title: "¿Tenés dudas sobre qué línea va con vos?", message: "Podés elegir ahora o seguir y decidir la línea más adelante.", stay: "Quiero elegir una línea", skip: "Saltar esta pregunta", leave: "Continuar después" },
		5: { title: "El color es el toque final", message: "El color define gran parte del estilo de la cocina. ¿Dejamos registrada tu preferencia?", stay: "Quiero elegir el color", skip: "Saltar esta pregunta", leave: "Continuar después" },
		6: { title: "¿Ya podemos instalar o todavía falta obra?", message: "Esta información nos ayuda a definir plazos y mostrarte el mejor camino.", stay: "Voy a responder ahora", skip: "Saltar esta pregunta", leave: "Continuar después" },
		7: { title: "¿Ya tenés una fecha en mente?", message: "Saber cuándo querés comprar nos ayuda a adaptar la propuesta a tu momento.", stay: "Quiero elegir una fecha", skip: "Saltar esta pregunta", leave: "Continuar después" },
		8: { title: "Queremos mostrarte lo mejor dentro de tu presupuesto", message: "Con ese valor en mente podemos armar una cocina que entre en tu bolsillo.", stay: "Voy a indicar mi presupuesto", skip: "Saltar esta pregunta", leave: "Continuar después" },
	};

	function showConfirmExit() {
		if (!modalConfirmOverlay || !modalConfirmTitle || !modalConfirmMessage || !modalConfirmStayBtn || !modalConfirmLeaveBtn) {
			return false;
		}
		if (currentStep < 2 || currentStep > totalSteps) {
			return false;
		}

		const i18nData = (i18n.exitConfirm && (i18n.exitConfirm[currentStep] || i18n.exitConfirm[String(currentStep)])) || null;
		const confirmData = i18nData || CONFIRM_EXIT_DEFAULTS[currentStep];
		if (!confirmData) return false;

		modalConfirmTitle.textContent = confirmData.title || "";
		modalConfirmMessage.innerHTML = confirmData.message || "";
		modalConfirmStayBtn.textContent = confirmData.stay || "Volver";
		if (modalConfirmSkipBtn) {
			// ÚLTIMA ETAPA (presupuesto): não existe "próxima pergunta" pra pular.
			// Antes, "Saltar esta pregunta" aqui caía em skipCurrentStep() ->
			// submitForm(), que era barrado pela validação e só pintava os cards
			// de vermelho — um beco sem saída pro usuário. Agora o botão nem
			// aparece: restam "responder agora" e "Continuar después".
			const isLastStep = currentStep >= totalSteps;
			modalConfirmSkipBtn.style.display = isLastStep ? "none" : "";
			modalConfirmSkipBtn.textContent = confirmData.skip || "Saltar esta pregunta";
		}
		modalConfirmLeaveBtn.textContent = confirmData.leave || "Continuar después";

		modalConfirmOverlay.classList.remove("hidden");
		return true;
	}

	function hideConfirmExit() {
		if (modalConfirmOverlay) modalConfirmOverlay.classList.add("hidden");
	}

	// -------------------------------------------------------------------
	// HELPERS DE TEXTO
	// -------------------------------------------------------------------
	function formatProgressFraction(step, total) {
		const tpl = i18n.progressTpl;
		if (tpl) {
			if (tpl.includes("__C__") || tpl.includes("__T__")) {
				return tpl.replace(/__C__/g, String(step)).replace(/__T__/g, String(total));
			}
			return tpl
				.replace(/\{\{\s*current\s*\}\}/gi, String(step))
				.replace(/\{\{\s*total\s*\}\}/gi, String(total));
		}
		return step + " / " + total;
	}

	function wallLabel(index) {
		const tpl = i18n.step3WallLabelTpl;
		if (tpl) return tpl.replace(/__N__/g, String(index));
		return "Pared " + index;
	}

	function unitCmSuffix() {
		return typeof i18n.unitCmSuffix === "string" ? i18n.unitCmSuffix : " cm";
	}

	function placeholderStep3Cm() {
		return typeof i18n.step3PlaceholderCm === "string" ? i18n.step3PlaceholderCm : "__ cm";
	}

	function uploadStatusLabel(count) {
		if (count === 1) return i18n.uploadOne || "";
		if (count > 1 && typeof i18n.uploadManyTpl === "string") {
			return i18n.uploadManyTpl.replace(/__COUNT__/g, String(count));
		}
		return "";
	}

	/** @type {Record<string, any>} */
	const formData = {};

	/** @returns {NodeListOf<HTMLElement>} */
	const getStepElements = () => modal.querySelectorAll(".form-step");

	// -------------------------------------------------------------------
	// ETAPA 3 — medidas dinâmicas por formato
	// -------------------------------------------------------------------
	/** @type {Record<string, number>} */
	const STEP3_INPUT_COUNT_BY_FORMAT = {
		"lineal": 1,
		"esquinera": 2,
		"paralela": 2,
		"en-u": 3,
		"otro": 0,
	};

	/** Legenda mostrada abaixo da ilustração, por formato. */
	const STEP3_MEASURE_LABEL = {
		"lineal": "Elegí el tamaño de la pared de tu cocina.",
		"esquinera": "Elegí el tamaño de la pared de tu cocina. Recordá sumar las medidas de las 2 paredes.",
		"paralela": "Elegí el tamaño de la pared de tu cocina. Recordá sumar las medidas de las 2 paredes.",
		"en-u": "Elegí el tamaño de la pared de tu cocina. Recordá sumar las medidas de las 3 paredes.",
	};

	function renderStep3ByFormat() {
		const step3InputsContainer = /** @type {HTMLElement | null} */ (modal.querySelector("[data-step3-inputs]"));
		const step3Illustration = /** @type {HTMLElement | null} */ (modal.querySelector("[data-step3-illustration]"));
		const step3MeasurePreview = /** @type {HTMLElement | null} */ (modal.querySelector(".step3-measure-preview"));
		const step3IllustrationImage = /** @type {HTMLImageElement | null} */ (modal.querySelector("[data-step3-illustration-image]"));
		const step3MeasureLabel = /** @type {HTMLElement | null} */ (modal.querySelector("[data-step3-measure-label]"));
		if (!step3InputsContainer || !step3Illustration) return;

		const selectedFormat = String(formData.format || "");
		const inputCount = STEP3_INPUT_COUNT_BY_FORMAT[selectedFormat] || 0;
		if (step3MeasurePreview) {
			step3MeasurePreview.hidden = inputCount === 0;
		}
		if (step3MeasureLabel) {
			step3MeasureLabel.textContent = STEP3_MEASURE_LABEL[selectedFormat] || "";
		}

		step3InputsContainer.innerHTML = "";

		// ⚠ NÃO apagar as medidas já preenchidas. A versão anterior fazia
		// `delete formData["parede" + i]` para as 3 paredes a cada re-render, e
		// como esta função roda também ao REABRIR o modal na etapa 3, ela
		// destruía exatamente o dado que o progresso salvo tinha acabado de
		// restaurar. Agora só limpamos as paredes que deixaram de existir no
		// formato escolhido (ex.: trocar "en U" por "lineal" descarta 2 e 3).
		const medidasSalvas = {};
		for (let i = 1; i <= 3; i += 1) {
			const digits = String(formData["parede" + i] || "").replace(/[^0-9]/g, "");
			if (i <= inputCount && digits) {
				medidasSalvas[i] = digits;
			} else {
				delete formData["parede" + i];
			}
		}

		for (let i = 1; i <= inputCount; i += 1) {
			const group = document.createElement("div");
			group.className = "form-group step3-form-group";

			const label = document.createElement("label");
			label.textContent = wallLabel(i);

			const input = document.createElement("input");
			input.type = "text";
			input.inputMode = "numeric";
			input.name = "parede" + i;
			input.placeholder = placeholderStep3Cm();
			input.required = true;
			if (medidasSalvas[i]) {
				input.value = medidasSalvas[i] + unitCmSuffix();
				formData["parede" + i] = input.value;
			}

			input.addEventListener("input", function () {
				const suf = unitCmSuffix();
				const numeric = this.value.replace(/[^0-9]/g, "");
				if (numeric) {
					this.value = numeric + suf;
					this.setSelectionRange(numeric.length, numeric.length);
				} else {
					this.value = "";
				}
			});

			input.addEventListener("blur", function () {
				const suf = unitCmSuffix();
				const numeric = this.value.replace(/[^0-9]/g, "");
				this.value = numeric ? numeric + suf : "";
			});

			group.appendChild(label);
			group.appendChild(input);
			step3InputsContainer.appendChild(group);
		}

		/** @type {Record<string, string | undefined>} */
		const illustrationSrcByFormat = {
			"lineal": step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageLineal : "",
			"esquinera": step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageEsquinera : "",
			"paralela": step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageParalela : "",
			"en-u": step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageEnU : "",
		};
		const nextIllustrationSrc = illustrationSrcByFormat[selectedFormat] || "";

		if (step3IllustrationImage) {
			step3IllustrationImage.src = nextIllustrationSrc;
			step3IllustrationImage.hidden = !nextIllustrationSrc;
		}

		updateStep3Buttons();
	}

	// -------------------------------------------------------------------
	// ESTADO DOS BOTÕES
	// -------------------------------------------------------------------
	function isStepReady(step) {
		if (step === 1) {
			const nome = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="nome"]'));
			const email = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="email"]'));
			const telefone = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="telefone"]'));
			return !!(nome && nome.value.trim() && email && email.value.trim() && telefone && telefone.value.trim());
		}
		const stepEl = /** @type {HTMLElement | null} */ (modal.querySelector('.form-step[data-step="' + step + '"]'));
		if (!stepEl) return true;
		if (step === 2 || step === 6 || step === 8) {
			return !!stepEl.querySelector(".option-btn.active");
		}
		if (step === 5) {
			return !!stepEl.querySelector(".step5-color-btn.active");
		}
		if (step === 7) {
			const dateInput = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="data-compra"]'));
			return !!(dateInput && dateInput.value);
		}
		return true;
	}

	function syncNextBtnState(step) {
		const stepsWithRequirements = [1, 2, 5, 6, 7, 8];
		if (stepsWithRequirements.indexOf(step) === -1) return;
		const stepEl = /** @type {HTMLElement | null} */ (modal.querySelector('.form-step[data-step="' + step + '"]'));
		if (!stepEl) return;
		const btn = /** @type {HTMLElement | null} */ (stepEl.querySelector("[data-next-step]:not(.step3-skip-btn):not(.step4-skip-btn)"));
		if (!btn) return;
		btn.classList.toggle("btn--pending", !isStepReady(step));
	}

	function updateStep3Buttons() {
		const advanceBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step3-advance-btn"));
		const skipBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step3-skip-btn"));
		if (!advanceBtn || !skipBtn) return;
		const hasMeasures = Array.prototype.some.call(
			modal.querySelectorAll('[name^="parede"]'),
			(input) => input.value && input.value.trim() !== ""
		);
		advanceBtn.style.display = hasMeasures ? "" : "none";
		skipBtn.style.display = hasMeasures ? "none" : "";
	}

	function updateStep4Buttons() {
		const advanceBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step4-next-btn"));
		const skipBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step4-skip-btn"));
		if (!advanceBtn || !skipBtn) return;
		const hasSelection = !!modal.querySelector('.form-step[data-step="4"] .option-btn.active');
		advanceBtn.style.display = hasSelection ? "" : "none";
		skipBtn.style.display = hasSelection ? "none" : "";
	}

	/** Etapa 5: mostra só as cores disponíveis na linha escolhida na etapa 4. */
	function renderStep5ByLine() {
		const selectedLine = String(formData.line || "");
		const colorBtns = /** @type {NodeListOf<HTMLButtonElement>} */ (modal.querySelectorAll(".step5-color-btn"));
		colorBtns.forEach((btn) => {
			if (!selectedLine) {
				btn.hidden = false;
				return;
			}
			const lines = (btn.getAttribute("data-lines") || "").split(",");
			btn.hidden = lines.indexOf(selectedLine) === -1;
			if (btn.hidden && btn.classList.contains("active")) {
				btn.classList.remove("active");
			}
		});
		const activeColors = Array.prototype.map.call(
			modal.querySelectorAll(".step5-color-btn.active"),
			(b) => b.getAttribute("data-value") || ""
		);
		formData.color = activeColors.join(",");
	}

	/** @param {Element | null} trigger */
	function getProductIdFromTrigger(trigger) {
		if (!trigger) return "";
		const selfProductId = trigger.getAttribute("data-product-id") || "";
		if (selfProductId.trim()) return selfProductId.trim();
		const cardWithProductId = /** @type {HTMLElement | null} */ (trigger.closest("[data-product-id]"));
		if (!cardWithProductId) return "";
		return (cardWithProductId.getAttribute("data-product-id") || "").trim();
	}

	// -------------------------------------------------------------------
	// UPLOAD — lista acumulada
	// -------------------------------------------------------------------
	/**
	 * O <input type="file"> SUBSTITUI input.files a cada nova seleção — sem
	 * esta lista acumulada, anexar um 2º arquivo apagaria o 1º.
	 * @type {File[]}
	 */
	let uploadedFiles = [];

	function getUploadInput() {
		return /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="step3_space_file"]'));
	}

	function syncUploadInput() {
		const input = getUploadInput();
		if (!input) return;
		try {
			const dt = new DataTransfer();
			uploadedFiles.forEach((f) => dt.items.add(f));
			input.files = dt.files;
		} catch (err) {
			// Navegador sem DataTransfer: uploadedFiles segue sendo a fonte de
			// verdade pro envio, então o upload não quebra.
			console.error("[modal-projeto-ar] Não foi possível sincronizar input.files.", err);
		}
	}

	/** @param {number} bytes */
	function formatFileSize(bytes) {
		if (bytes < 1024) return bytes + " B";
		if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " KB";
		return (bytes / (1024 * 1024)).toFixed(1).replace(".", ",") + " MB";
	}

	/**
	 * Renderiza a lista de anexos com botão de remover individual.
	 * Usa textContent (nunca innerHTML) pro nome do arquivo — nome de arquivo
	 * é conteúdo controlado por quem faz upload.
	 */
	function renderUploadList() {
		const list = modal.querySelector("[data-upload-list]");
		if (!list) return;

		list.innerHTML = "";

		if (!uploadedFiles.length) {
			list.hidden = true;
			return;
		}
		list.hidden = false;

		uploadedFiles.forEach((file, index) => {
			const item = document.createElement("li");
			item.className = "step3-upload-item";

			const name = document.createElement("span");
			name.className = "step3-upload-item__name";
			name.textContent = file.name;
			name.title = file.name;

			const size = document.createElement("span");
			size.className = "step3-upload-item__size";
			size.textContent = formatFileSize(file.size);

			const remove = document.createElement("button");
			remove.type = "button";
			remove.className = "step3-upload-item__remove";
			remove.setAttribute("data-upload-remove", String(index));
			remove.setAttribute("aria-label", "Quitar " + file.name);
			remove.textContent = "×"; // ×

			item.appendChild(name);
			item.appendChild(size);
			item.appendChild(remove);
			list.appendChild(item);
		});
	}

	function renderUploadStatus() {
		formData.space_file = uploadedFiles.map((f) => f.name).join(", ");
		const label = uploadStatusLabel(uploadedFiles.length);
		modal.querySelectorAll("[data-upload-filename]").forEach((el) => {
			el.textContent = label;
		});
		renderUploadList();
	}

	/** @param {number} index */
	function removeUploadFile(index) {
		if (index < 0 || index >= uploadedFiles.length) return;
		uploadedFiles.splice(index, 1);
		syncUploadInput();
		renderUploadStatus();
	}

	function getUploadFiles() {
		return uploadedFiles.slice();
	}

	/** @param {File[]} files */
	function validateUploadFiles(files) {
		if (!files.length) return null;

		let totalBytes = 0;
		for (const file of files) {
			const isImage = file.type.indexOf("image/") === 0;
			// Alguns navegadores/SOs não informam o MIME — fallback pela extensão.
			const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
			if (!isImage && !isPdf) {
				return "Adjuntá solamente imágenes o archivos PDF.";
			}
			if (file.size > MAX_FILE_SIZE_BYTES) {
				return 'El archivo "' + file.name + '" supera los ' + MAX_FILE_MB + "MB.";
			}
			totalBytes += file.size;
		}

		if (totalBytes > MAX_FILE_SIZE_BYTES) {
			return "Los archivos suman " + Math.ceil(totalBytes / (1024 * 1024)) + "MB. El total no puede superar los " + MAX_FILE_MB + "MB.";
		}
		return null;
	}

	// -------------------------------------------------------------------
	// ENVIO — HubSpot Forms Submission API v3
	// -------------------------------------------------------------------

	/** slug do DOM -> rótulo HubSpot (passthrough se não mapeado) */
	function mapVal(map, slug) {
		if (slug === undefined || slug === null || slug === "") return "";
		return map && Object.prototype.hasOwnProperty.call(map, slug) ? map[slug] : slug;
	}

	/**
	 * Monta o array { name, value } da Forms API a partir do formData.
	 * Usa Map (não array) para que um campo em `extra` possa SOBRESCREVER um
	 * valor definido antes — é o que permite marcar desistentes sem duplicar
	 * chaves no payload.
	 * @param {Array<{name:string,value:string}>} [extra]
	 */
	function buildHubspotFields(extra) {
		const fieldsMap = new Map();
		const push = (name, value) => {
			if (name && value !== "" && value != null) fieldsMap.set(name, String(value));
		};

		// Etapa 1 — dados pessoais
		push(FIELD_MAP.nome, String(formData.nome || "").trim());
		push(FIELD_MAP.email, String(formData.email || "").trim());
		// normalizarTelefoneAR() já devolve SÓ os 10 dígitos nacionais, sem DDI,
		// sem o 9 de celular e sem o 0 inicial. Por isso o DDI é sempre
		// acrescentado aqui, sem checagem — a checagem antiga ("já começa com
		// 54?") dava falso positivo quando a máscara truncava o número.
		// Resultado: 13 dígitos, nada além de dígitos ("5491111111111").
		const tel = normalizarTelefoneAR(formData.telefone);
		if (tel.length === 10) {
			push(FIELD_MAP.telefone, PHONE_DDI + PHONE_MOBILE_9 + tel);
		}

		// Etapa 2 — formato
		push(FIELD_MAP.formato, mapVal(VALUE_MAP.formato, String(formData.formato || "")));

		// Etapa 3 — medidas das paredes, combinadas num texto único
		// ("Pared 1: 300cm, Pared 2: 250cm"). Se o form AR tiver campos
		// parede_1/2/3 separados, trocar este bloco por três push().
		{
			const paredesTexto = [];
			for (let i = 1; i <= 3; i += 1) {
				const digits = String(formData["parede" + i] || "").replace(/[^0-9]/g, "");
				if (digits) paredesTexto.push("Pared " + i + ": " + digits + "cm");
			}
			push(FIELD_MAP.medidasTexto, paredesTexto.join(", "));
		}

		// Etapa 4 — línea (opcional)
		push(FIELD_MAP.linha, mapVal(VALUE_MAP.linha, String(formData.line || "")));

		// Etapa 5 — color (multi, até 2) -> unido com ";"
		const colores = String(formData.color || "")
			.split(",")
			.map((s) => s.trim())
			.filter(Boolean)
			.map((s) => mapVal(VALUE_MAP.color, s));
		push(FIELD_MAP.color, colores.join(";"));

		// Etapa 6 — espacio listo
		push(FIELD_MAP.espacio, mapVal(VALUE_MAP.espacio, String(formData.espacioListo || "")));

		// Etapa 7 — fecha (month "YYYY-MM" -> epoch ms UTC)
		const dc = String(formData.data_compra || "").trim();
		if (dc) {
			const p = dc.split("-");
			const day = p[2] ? +p[2] : 1;
			push(FIELD_MAP.data_compra, String(Date.UTC(+p[0], +p[1] - 1, day)));
		}

		// Etapa 8 — presupuesto
		push(FIELD_MAP.presupuesto, mapVal(VALUE_MAP.presupuesto, String(formData.presupuesto || "")));

		// Opcionais (só se o nome estiver configurado no FIELD_MAP)
		push(FIELD_MAP.gclid, win.__gclidAr || "");
		push(FIELD_MAP.sku, String(openerProductId || "").trim());

		// Ocultos fixos
		HIDDEN_FIELDS.forEach((f) => push(f.name, f.value));

		// Extras — processados por último, então SOBRESCREVEM o que veio antes.
		if (extra) extra.forEach((f) => push(f.name, f.value));

		// Blindagem: os campos REAIS de origem nunca saem neste payload.
		NEVER_SEND_DIRECTLY.forEach((name) => fieldsMap.delete(name));

		return Array.from(fieldsMap, ([name, value]) => ({ name, value }));
	}

	/** @param {Array<{name:string,value:string}>} fields */
	function debugFields(fields) {
		fields.forEach((f) => console.log("[modal-projeto-ar]", f.name, "=", f.value));
	}

	/**
	 * POST na Forms API. Lança erro em resposta !ok.
	 *
	 * `opts.keepalive` mantém o POST vivo mesmo se a página navegar logo em
	 * seguida — usado na captação antecipada e no registro de desistência,
	 * que agora podem ser seguidos do redirect pra página de gracias. O
	 * payload é pequeno, bem abaixo do limite de 64KB do keepalive.
	 *
	 * @param {Array<{name:string,value:string}>} fields
	 * @param {string} [ipAddress]
	 * @param {{keepalive?: boolean}} [opts]
	 */
	function postToHubspot(fields, ipAddress, opts) {
		if (!FORM_ID) {
			console.warn(
				"[modal-projeto-ar] FORM_ID vazio (TODO-AR): envio para a HubSpot PULADO.",
				"\n  Campos que seriam enviados:", fields
			);
			return Promise.resolve({ skipped: true });
		}

		const ctx = { pageUri: window.location.href, pageName: document.title };
		const hutk = getHutk();
		if (hutk) ctx.hutk = hutk;   // NUNCA enviar hutk vazio — a API rejeita
		if (ipAddress) ctx.ipAddress = ipAddress;

		const reqInit = {
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify({ fields: fields, context: ctx, legalConsentOptions: LEGAL_CONSENT }),
		};
		if (opts && opts.keepalive) reqInit.keepalive = true;

		return fetch(SUBMIT_URL, reqInit).then((res) =>
			res
				.json()
				.catch(() => ({}))
				.then((data) => {
					if (!res.ok) {
						console.error("[modal-projeto-ar] Falha no envio", res.status, data);
						throw new Error((data && data.message) || "No pudimos enviar el formulario (" + res.status + ").");
					}
					return data;
				}),
		);
	}

	/**
	 * Captação antecipada do lead: ao avançar da etapa 1, cria/atualiza o
	 * contato já com nome/e-mail/telefone. Best-effort — nunca bloqueia o quiz.
	 * ⚠ Nesta altura só os campos de contato estão preenchidos: é ESPERADO que
	 * os demais cheguem vazios na HubSpot. Não conclua que "o campo não
	 * funciona" olhando o contato logo após esta chamada.
	 */
	function captureLead() {
		if (!EARLY_LEAD_CAPTURE_ENABLED) return;
		if (leadCaptured) return;
		leadCaptured = true;
		// Persistido no progresso: se a pessoa recarregar a página e voltar pra
		// etapa 1, não dispara uma segunda captação do mesmo contato.
		saveProgress();
		try {
			postToHubspot(buildHubspotFields(), "", { keepalive: true }).catch((err) => {
				console.error("[modal-projeto-ar] Captação inicial do lead falhou (quiz segue normalmente).", err);
			});
		} catch (err) {
			console.error("[modal-projeto-ar] Erro inesperado na captação inicial do lead.", err);
		}
	}

	/**
	 * Registra a etapa em que a pessoa desistiu, junto com o que já foi
	 * preenchido. Sobrescreve a origem staging com o valor de desistente.
	 * Best-effort: dispara e não bloqueia o fechamento do modal.
	 *
	 * Vai com keepalive porque, desde o redirect, logo depois disto a página
	 * navega para a URL de gracias — sem keepalive o navegador cancelaria
	 * este POST no meio e a desistência não seria registrada.
	 *
	 * @param {string} stepSlug
	 */
	function recordExit(stepSlug) {
		if (!stepSlug) {
			console.warn(
				"[modal-projeto-ar] 'Continuar después' clicado sem etapa mapeada em EXIT_STEP",
				"(currentStep =", currentStep, ") — nada foi registrado na HubSpot."
			);
			return;
		}

		// SEM BLOQUEIO DE REPETIÇÃO, por decisão de produto: TODO clique em
		// "Continuar después" registra a etapa atual, mesmo que seja a mesma de
		// antes. Consequência aceita: abrir e sair 3 vezes na mesma pergunta
		// gera 3 envios de formulário na HubSpot para o mesmo contato (o valor
		// da etapa não duplica, mas a contagem de envios do form sobe).
		// `lastExitStepRecorded` continua existindo só para diagnóstico.
		//
		// ⚠ Com o reenvio liberado, quem JÁ CONCLUIU o quiz e depois recomeçar
		// e desistir no meio volta a gravar uma etapa de desistência por cima
		// do "Concluído". É o efeito esperado da decisão de permitir reenvio.
		const isRepeat = lastExitStepRecorded === stepSlug;
		lastExitStepRecorded = stepSlug;

		try {
			console.log(
				"[modal-projeto-ar] DESISTÊNCIA →",
				"\n  campo:", EXIT_FIELD,
				"\n  valor:", stepSlug,
				"\n  etapa:", currentStep,
				isRepeat ? "\n  (registro repetido da mesma etapa — esperado)" : "",
				"\n  (se este valor não aparecer no contato, o problema é o enum da propriedade",
				"ou o campo não está adicionado ao formulário — não é o código)"
			);
			postToHubspot(
				buildHubspotFields([
					{ name: EXIT_FIELD, value: stepSlug },
					{ name: "origem_de_cadastro_staging", value: ORIGIN_DESISTENTE },
					{ name: "origem_de_cadastro__crm__staging", value: ORIGIN_DESISTENTE },
				]),
				"",
				{ keepalive: true },
			).catch((err) => {
				console.error("[modal-projeto-ar] Registro da etapa de desistência falhou.", err);
			});
		} catch (err) {
			console.error("[modal-projeto-ar] Erro inesperado ao registrar desistência.", err);
		}
	}

	/**
	 * Cria (ou reaproveita) o iframe oculto que recebe o POST do upload.
	 * IFRAME COM ID FIXO, NUNCA REMOVIDO: ele é o target do POST, e destruí-lo
	 * antes da HubSpot terminar interrompe o upload no meio.
	 *
	 * ⚠ Por que esperar o primeiro "load": um iframe recém-criado dispara um
	 * "load" do próprio about:blank. Se escutássemos o load logo depois do
	 * form.submit(), esse evento fantasma seria confundido com "a HubSpot
	 * respondeu" — e o redirect sairia no meio do upload. Esperando o load
	 * inicial ANTES de montar o form, o próximo load é, com certeza, a resposta.
	 */
	const UPLOAD_IFRAME_NAME = "mpar-file-upload-frame";

	function ensureUploadFrame() {
		return new Promise((resolve) => {
			const existing = document.getElementById(UPLOAD_IFRAME_NAME);
			if (existing) {
				resolve(existing);
				return;
			}

			const iframe = document.createElement("iframe");
			iframe.name = UPLOAD_IFRAME_NAME;
			iframe.id = UPLOAD_IFRAME_NAME;
			iframe.style.display = "none";

			let settled = false;
			const done = () => {
				if (!settled) {
					settled = true;
					resolve(iframe);
				}
			};

			iframe.addEventListener("load", function onFirstLoad() {
				iframe.removeEventListener("load", onFirstLoad);
				done();
			});
			window.setTimeout(done, 1000);   // fallback: navegador que não dispare o load inicial

			document.body.appendChild(iframe);
		});
	}

	/**
	 * Upload dos anexos da etapa 3 para o form dedicado da HubSpot.
	 *
	 * UMA submissão, UM campo de arquivo recebendo TODOS os anexos — a
	 * propriedade da HubSpot (tipo arquivo) lista vários arquivos quando eles
	 * vão juntos num só <input type="file" multiple>. NÃO crie um campo por
	 * arquivo nem um POST por arquivo.
	 *
	 * Vai por <form>+<iframe> ocultos porque o endpoint v2 não libera CORS
	 * (fetch/XHR são bloqueados; POST tradicional de formulário não é).
	 * Consequência aceita por design: a resposta NÃO é LEGÍVEL via JS. Para
	 * conferir o conteúdo, use DevTools → Network, filtro "uploads".
	 *
	 * Retorna uma Promise que resolve quando o iframe RECEBE a resposta (dá
	 * pra saber que ela chegou, mesmo sem poder lê-la) ou quando estoura
	 * FILE_UPLOAD_WAIT_MS. É isso que segura o redirect até o upload terminar.
	 * A Promise NUNCA rejeita: o upload segue best-effort por design.
	 *
	 * @param {string} email
	 * @param {File[]} files
	 */
	function submitFileViaHiddenIframe(email, files) {
		if (!FILE_FORM_ID || !FILE_FIELD) {
			console.warn("[modal-projeto-ar] FILE_FORM_ID/FILE_FIELD vazios (TODO-AR): upload PULADO com segurança.");
			return Promise.resolve();
		}
		if (!files || !files.length) return Promise.resolve();

		return new Promise((resolve) => {
			let done = false;
			const finish = () => {
				if (!done) {
					done = true;
					resolve();
				}
			};

			// Teto global: mesmo que nada responda, o redirect não fica preso.
			window.setTimeout(finish, FILE_UPLOAD_WAIT_MS);

			try {
				ensureUploadFrame().then((iframe) => {
					try {
						const form = document.createElement("form");
						form.action = LEGACY_FILE_UPLOAD_URL;
						form.method = "POST";
						form.enctype = "multipart/form-data";
						form.target = UPLOAD_IFRAME_NAME;
						form.style.display = "none";

						const emailInput = document.createElement("input");
						emailInput.type = "hidden";
						emailInput.name = "email";
						emailInput.value = email || "";
						form.appendChild(emailInput);

						const ctxInput = document.createElement("input");
						ctxInput.type = "hidden";
						ctxInput.name = "hs_context";
						ctxInput.value = JSON.stringify({
							pageUri: window.location.href,
							pageName: document.title,
							hutk: getHutk(),
						});
						form.appendChild(ctxInput);

						// UM input com TODOS os arquivos.
						const fileInput = document.createElement("input");
						fileInput.type = "file";
						fileInput.name = FILE_FIELD;
						fileInput.multiple = true;
						const dt = new DataTransfer();
						Array.prototype.forEach.call(files, (f) => dt.items.add(f));
						fileInput.files = dt.files;
						form.appendChild(fileInput);

						// "load" agora = resposta da HubSpot ao POST (ver ensureUploadFrame).
						const onLoad = () => {
							iframe.removeEventListener("load", onLoad);
							finish();
						};
						iframe.addEventListener("load", onLoad);

						document.body.appendChild(form);

						console.log(
							"[modal-projeto-ar] UPLOAD →", LEGACY_FILE_UPLOAD_URL,
							"\n  campo:", FILE_FIELD,
							"\n  email:", email || "(vazio)",
							"\n  arquivos:", Array.prototype.map.call(files, (f) => f.name + " (" + f.size + "b)").join(" | "),
						);

						form.submit();
						// Remove SÓ o form, mantendo o iframe vivo. 30s = margem pra conexão lenta.
						window.setTimeout(() => form.remove(), 30000);
					} catch (err) {
						console.error("[modal-projeto-ar] Falha no upload — quiz principal segue normalmente.", err);
						finish();
					}
				});
			} catch (err) {
				console.error("[modal-projeto-ar] Falha ao preparar o iframe de upload — quiz principal segue normalmente.", err);
				finish();
			}
		});
	}

	/** @param {boolean} loading */
	function setSubmitLoading(loading) {
		const submitBtn = /** @type {HTMLButtonElement | null} */ (modal.querySelector("[data-submit]"));
		if (!submitBtn) return;
		submitBtn.disabled = loading;
		submitBtn.setAttribute("aria-busy", loading ? "true" : "false");
	}

	// -------------------------------------------------------------------
	// NAVEGAÇÃO
	// -------------------------------------------------------------------
	/** @param {number} step */
	function showStep(step) {
		getStepElements().forEach((el) => el.classList.remove("active"));

		const stepElements = getStepElements();
		let activeStepElement = null;
		if (stepElements[step]) {
			activeStepElement = stepElements[step];
			activeStepElement.classList.add("active");
		}

		const modalContainer = modal.querySelector(".modal-container");
		if (modalContainer) {
			const isSuccessStep = !!activeStepElement && activeStepElement.getAttribute("data-step") === "success";
			modalContainer.classList.toggle("is-success-step", isSuccessStep);
		}

		if (step > 0 && step <= totalSteps) {
			modal.querySelectorAll("#progress-counter").forEach((el) => {
				el.textContent = formatProgressFraction(step, totalSteps);
			});
		}

		const modalContent = modal.querySelector(".modal-content");
		if (modalContent) modalContent.scrollTop = 0;

		if (step === 3) {
			renderStep3ByFormat();
			updateStep3Buttons();
		}
		if (step === 4) updateStep4Buttons();
		if (step === 5) renderStep5ByLine();

		syncNextBtnState(step);
		currentStep = step;

		// Salva a cada etapa exibida, não só quando a pessoa clica em
		// "Continuar después". Assim fechar a aba, recarregar a página ou perder
		// a conexão não apaga o que já foi respondido.
		if (step >= 1 && step <= totalSteps) saveProgress();
	}

	function resetForm() {
		Object.keys(formData).forEach((key) => delete formData[key]);
		openerProductId = "";
		uploadedFiles = [];
		modal.querySelectorAll("input").forEach((input) => {
			if (input.type === "checkbox") {
				input.checked = false;
			} else {
				input.value = "";
			}
		});
		modal.querySelectorAll(".option-btn.active").forEach((btn) => btn.classList.remove("active"));
		modal.querySelectorAll("[data-upload-filename]").forEach((el) => {
			el.textContent = "";
		});
		renderUploadList();
	}

	/**
	 * Repõe no DOM tudo que está no formData (progresso restaurado).
	 *
	 * Sem isto o progresso salvo era meia-verdade: o formData voltava, mas os
	 * inputs apareciam em branco e os cards escolhidos sem a classe .active —
	 * a pessoa via um formulário vazio numa etapa avançada, e o botão
	 * "Siguiente" ficava travado porque isStepReady() olha o DOM, não o
	 * formData.
	 *
	 * Anexos NÃO são restauráveis: objetos File não podem ser serializados, e
	 * nenhum navegador permite recriar a seleção de arquivo por JS. Quem
	 * desistir na etapa 3 depois de anexar precisa anexar de novo.
	 */
	function restoreFormDataToDom() {
		/** @param {string} name @param {any} value */
		const setInput = (name, value) => {
			if (value === undefined || value === null || value === "") return;
			const input = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="' + name + '"]'));
			if (input) input.value = String(value);
		};

		setInput("nome", formData.nome);
		setInput("email", formData.email);
		setInput("telefone", formData.telefone);
		setInput("data-compra", formData.data_compra);

		/** @param {number} step @param {string} value */
		const activateOption = (step, value) => {
			if (!value) return;
			const stepEl = /** @type {HTMLElement | null} */ (modal.querySelector('.form-step[data-step="' + step + '"]'));
			if (!stepEl) return;
			const btn = /** @type {HTMLElement | null} */ (stepEl.querySelector('.option-btn[data-value="' + value + '"]'));
			if (btn) btn.classList.add("active");
		};

		activateOption(2, String(formData.formato || formData.format || ""));
		activateOption(4, String(formData.line || ""));
		activateOption(6, String(formData.espacioListo || ""));
		activateOption(8, String(formData.presupuesto || ""));

		// Cores são múltiplas (até 2), guardadas como "gris,negro".
		String(formData.color || "")
			.split(",")
			.map((s) => s.trim())
			.filter(Boolean)
			.forEach((cor) => activateOption(5, cor));

		// Etapa 4 e 5 dependem uma da outra (a linha filtra as cores),
		// e os botões de avançar/pular da 3 e 4 dependem da seleção.
		renderStep5ByLine();
		updateStep4Buttons();
		updateStep3Buttons();
	}

	/** @param {string} [productId] */
	function openModal(productId) {
		const gclidField = /** @type {HTMLInputElement | null} */ (modal.querySelector("#modal-ar-gclid-field"));
		if (gclidField) gclidField.value = win.__gclidAr || "";

		openerProductId = String(productId || "").trim();

		// ⚠ REENVIO LIBERADO: não há mais checagem de "já concluiu". Quem
		// terminou o quiz teve o progresso limpo no submitForm(), então reabre
		// na etapa 0 e pode responder de novo — igual ao México. Quem abandonou
		// no meio continua retomando de onde parou (progresso vale 7 dias).
		const savedProgress = loadProgress();
		if (savedProgress && savedProgress.step >= 1) {
			currentStep = savedProgress.step;
			Object.assign(formData, savedProgress.formData || {});
			if (savedProgress.productId) openerProductId = savedProgress.productId;
			// Retomados dos POSTs já feitos, pra não repetir nenhum.
			leadCaptured = !!savedProgress.leadCaptured;
			lastExitStepRecorded = String(savedProgress.lastExitStep || "");
			restoreFormDataToDom();
		} else {
			currentStep = 0;
		}

		if (openerProductId) formData.sku = openerProductId;

		modal.classList.remove("hidden");
		showStep(currentStep);
		document.body.classList.add("project-start-modal-open");
	}

	function closeModal(force) {
		// Nas etapas 2..8 o X NUNCA fecha direto: abre a confirmação de saída.
		if (!force && currentStep >= 2 && currentStep <= totalSteps) {
			showConfirmExit();
			return;
		}

		// Guardados antes do reset, pra decidir o redirect depois de fechar.
		const wasSuccessScreen = currentStep > totalSteps;
		const stepAtClose = currentStep;

		modal.classList.add("hidden");
		hideConfirmExit();
		currentStep = 0;
		resetForm();
		clearProgress();
		document.body.classList.remove("project-start-modal-open");

		// Tela de agradecimento: o redirect já foi agendado pelo submitForm().
		// Se existe, antecipamos; se ainda não existe, é porque o upload dos
		// anexos está em andamento — nesse caso NÃO navegamos aqui, pra não
		// cancelar o upload: o fluxo normal leva pra gracias quando terminar.
		if (wasSuccessScreen) {
			if (redirecting) goToThankYou(0, true);
			return;
		}

		// Etapas 0 e 1: por padrão (REDIRECT_ON_CLOSE_MIN_QI = 2) não
		// redirecionam, porque aqui ainda não existe lead — mandar essa pessoa
		// pra página de gracias contaria uma conversão que não aconteceu.
		if (stepAtClose >= REDIRECT_ON_CLOSE_MIN_QI) goToThankYou(0);
	}
	// -------------------------------------------------------------------
	// VALIDAÇÃO
	// -------------------------------------------------------------------
	/** @param {HTMLInputElement | null} field */
	function showFieldError(field) {
		if (!field) return;
		field.style.borderColor = "#e11923";
		field.style.boxShadow = "0 0 0 2px rgba(225, 25, 35, 0.1)";
	}

	/** @param {HTMLInputElement | null} field */
	function clearFieldError(field) {
		if (!field) return;
		field.style.borderColor = "";
		field.style.boxShadow = "";
	}

	/** @param {string} email */
	function isValidEmail(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}

	/**
	 * Reduz o que a pessoa digitou aos 10 dígitos nacionais argentinos.
	 *
	 * ⚠ ESTA FUNÇÃO EXISTE POR CAUSA DE UM BUG REAL, confirmado em QA
	 * automatizado. A versão anterior só fazia `replace(/\D/g,"").slice(0,10)`.
	 * Quem digitava "+54 11 5555-1234" virava "5411555512": os 12 dígitos eram
	 * cortados em 10, decapitando o final do número. Pior, o resultado passava
	 * a começar com "54", e a checagem de DDI lá embaixo concluía que o país já
	 * estava lá e não acrescentava o 9. O telefone chegava mutilado na HubSpot
	 * sem erro nenhum aparecer — lead que ninguém consegue ligar.
	 *
	 * Formatos aceitos agora:
	 *   11 5555 1234        -> 1155551234
	 *   +54 11 5555-1234    -> 1155551234   (tira o DDI)
	 *   +54 9 11 5555-1234  -> 1155551234   (tira o DDI e o 9 de celular)
	 *   011 5555-1234       -> 1155551234   (tira o 0 do formato nacional)
	 *
	 * O corte para 10 só acontece DEPOIS de remover os prefixos, nunca antes.
	 * @param {string} value
	 */
	function normalizarTelefoneAR(value) {
		let d = String(value || "").replace(/\D/g, "");
		// DDI: só remove se sobrar número demais — assim um número nacional
		// legítimo de 10 dígitos nunca é mutilado por engano.
		if (d.length > 10 && d.indexOf("54") === 0) {
			d = d.slice(2);
			if (d.length > 10 && d.indexOf("9") === 0) d = d.slice(1);
		}
		// 0 inicial do formato nacional ("011 ...")
		if (d.length > 10 && d.indexOf("0") === 0) d = d.slice(1);
		return d.slice(0, 10);
	}

	/**
	 * Telefone Argentina — exibição.
	 * Deliberadamente SEM máscara rígida: ao contrário do Brasil (DDD sempre
	 * com 2 dígitos), na Argentina o código de área tem de 2 a 4 dígitos
	 * (11 em Buenos Aires, 351 em Córdoba, 2966 em Río Gallegos...). Uma
	 * máscara fixa "(NN) NNNN-NNNN" mutilaria os números do interior.
	 * @param {string} value
	 */
	function formatArgentinaPhone(value) {
		const digits = normalizarTelefoneAR(value);
		if (!digits) return "";
		if (digits.length <= 4) return digits;
		if (digits.length <= 8) return digits.slice(0, 2) + " " + digits.slice(2);
		return digits.slice(0, 2) + " " + digits.slice(2, 6) + " " + digits.slice(6);
	}

	/** @param {string} value */
	function isValidArgentinaPhone(value) {
		return normalizarTelefoneAR(value).length === 10;
	}

	/** @param {HTMLElement | null} stepElement */
	function getActiveOptionValue(stepElement) {
		if (!stepElement) return null;
		const activeBtn = /** @type {HTMLButtonElement | null} */ (stepElement.querySelector(".option-btn.active"));
		return activeBtn ? activeBtn.getAttribute("data-value") : null;
	}

	/** @param {HTMLElement | null} stepElement */
	function highlightOptionGroupError(stepElement) {
		if (!stepElement) return;
		stepElement.querySelectorAll(".option-btn").forEach((btn) => {
			if (btn instanceof HTMLElement) btn.style.borderColor = "#e11923";
		});
	}

	/** @param {HTMLElement | null} stepElement */
	function clearOptionGroupError(stepElement) {
		if (!stepElement) return;
		stepElement.querySelectorAll(".option-btn").forEach((btn) => {
			if (btn instanceof HTMLElement) btn.style.borderColor = "";
		});
	}

	function validateStep1() {
		const nome = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="nome"]'));
		const email = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="email"]'));
		const telefone = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="telefone"]'));
		let valid = true;

		if (!nome || !nome.value.trim()) {
			showFieldError(nome);
			valid = false;
		} else {
			clearFieldError(nome);
			formData.nome = nome.value;
		}

		if (!email || !email.value.trim() || !isValidEmail(email.value)) {
			showFieldError(email);
			valid = false;
		} else {
			clearFieldError(email);
			formData.email = email.value;
		}

		if (!telefone || !telefone.value.trim() || !isValidArgentinaPhone(telefone.value)) {
			showFieldError(telefone);
			valid = false;
		} else {
			clearFieldError(telefone);
			formData.telefone = telefone.value;
		}

		return valid;
	}

	function validateCurrentStep() {
		if (currentStep === 0) return true;
		if (currentStep === 1) return validateStep1();

		const stepElement = /** @type {HTMLElement | null} */ (modal.querySelector('.form-step[data-step="' + currentStep + '"]'));
		if (!stepElement) return true;

		// Obrigatórias com escolha única: formato, espacio listo, presupuesto.
		if (currentStep === 2 || currentStep === 6 || currentStep === 8) {
			const selectedValue = getActiveOptionValue(stepElement);
			if (!selectedValue) {
				highlightOptionGroupError(stepElement);
				return false;
			}
			clearOptionGroupError(stepElement);
			if (currentStep === 2) {
				formData.format = selectedValue;
				formData.formato = selectedValue;
			}
			if (currentStep === 6) formData.espacioListo = selectedValue;
			if (currentStep === 8) formData.presupuesto = selectedValue;
			return true;
		}

		// Etapa 3 — opcional: guarda o que estiver preenchido.
		if (currentStep === 3) {
			const allInputs = /** @type {NodeListOf<HTMLInputElement>} */ (stepElement.querySelectorAll("[data-step3-inputs] input"));
			allInputs.forEach((input) => {
				clearFieldError(input);
				if (input.value.trim()) formData[input.name] = input.value;
			});
			return true;
		}

		// Etapa 4 — opcional.
		if (currentStep === 4) {
			const selectedValue = getActiveOptionValue(stepElement);
			clearOptionGroupError(stepElement);
			if (selectedValue) formData.line = selectedValue;
			return true;
		}

		// Etapa 5 — obrigatória, até 2 cores.
		if (currentStep === 5) {
			const activeColors = Array.prototype.map.call(
				stepElement.querySelectorAll(".step5-color-btn.active"),
				(b) => b.getAttribute("data-value") || ""
			);
			if (!activeColors.length) {
				highlightOptionGroupError(stepElement);
				return false;
			}
			clearOptionGroupError(stepElement);
			formData.color = activeColors.join(",");
			return true;
		}

		// Etapa 7 — data obrigatória, dentro da janela permitida.
		if (currentStep === 7) {
			const dataCompra = /** @type {HTMLInputElement | null} */ (stepElement.querySelector('input[name="data-compra"]'));
			if (!dataCompra || !dataCompra.value.trim() || dataCompra.value < dataCompra.min || dataCompra.value > dataCompra.max) {
				showFieldError(dataCompra);
				return false;
			}
			clearFieldError(dataCompra);
			formData.data_compra = dataCompra.value;
			return true;
		}

		return true;
	}

	function nextStep() {
		if (currentStep < totalSteps) {
			if (!validateCurrentStep()) return;

			const stepBeforeAdvance = currentStep;
			const advanceEvent = MODAL_STEP_ADVANCE_EVENTS[stepBeforeAdvance];
			if (advanceEvent) trackProjetoEvent(advanceEvent, {});

			// Captação antecipada ao concluir a etapa 1 (dados pessoais).
			if (stepBeforeAdvance === 1) captureLead();

			currentStep += 1;
			showStep(currentStep);
			return;
		}

		currentStep = totalSteps + 1;
		showStep(getStepElements().length - 1);
	}

	/**
	 * Pula a pergunta atual SEM validar (botão "Saltar esta pregunta" do card
	 * de confirmação de saída). Diferente de nextStep(): não bloqueia em etapa
	 * obrigatória e não dispara o evento de tracking da etapa.
	 * Não redireciona: a pessoa continua no quiz.
	 */
	function skipCurrentStep() {
		hideConfirmExit();
		if (currentStep < totalSteps) {
			currentStep += 1;
			showStep(currentStep);
			return;
		}
		submitForm();
	}

	function goBack() {
		if (currentStep > totalSteps) {
			// Tela de agradecimento: a seta volta pra última pergunta.
			// ⚠ Com o reenvio liberado, daqui a pessoa PODE enviar de novo e
			// gerar uma segunda submissão do mesmo lead — é o comportamento
			// pedido (mesmo do México), não um bug.
			// ⚠ Com o redirect ligado, esta volta dura pouco: o redirect da
			// conclusão já está agendado e a página navega em seguida.
			showStep(totalSteps);
			return;
		}
		if (currentStep > 0) {
			currentStep -= 1;
			showStep(currentStep);
			return;
		}
		closeModal(false);
	}

	async function submitForm() {
		if (isSubmitting) return;   // trava só o clique duplo no MESMO envio
		if (!validateCurrentStep()) return;

		trackProjetoEvent("presupuesto_modal", {});

		const fileValidationError = validateUploadFiles(getUploadFiles());
		if (fileValidationError) {
			window.alert(fileValidationError);
			return;
		}

		isSubmitting = true;
		setSubmitLoading(true);

		// Upload em paralelo (best-effort — nunca bloqueia o envio principal).
		// `filePromise` resolve quando o upload responde (ou estoura o teto) e é
		// o que segura o redirect até os anexos terem subido.
		let filePromise = null;
		try {
			const files = getUploadFiles();
			if (files.length) {
				filePromise = submitFileViaHiddenIframe(String(formData.email || "").trim(), files);
			}
		} catch (err) {
			console.error("[modal-projeto-ar] Erro inesperado ao disparar upload.", err);
		}

		// Envio final: única vez em que a origem "normal" é enviada nesta sessão.
		const finalExtras = ORIGIN_STAGING_NORMAL.slice();
		if (SEND_COMPLETED_EXIT_STEP) {
			// Processado depois de tudo em buildHubspotFields() (que usa Map),
			// então este valor SOBRESCREVE a etapa de desistência que estaria no
			// payload. Quem desistiu na etapa 4 e voltou pra concluir termina
			// como "Concluído", não como "linea".
			finalExtras.push({ name: EXIT_FIELD, value: EXIT_STEP_COMPLETED });
		}
		const fields = buildHubspotFields(finalExtras);
		debugFields(fields);

		// IP best-effort (não bloqueia)
		let ip = "";
		try {
			ip = await fetch("https://api.ipify.org?format=json")
				.then((r) => r.json())
				.then((d) => d.ip)
				.catch(() => "");
		} catch (e) {
			ip = "";
		}

		try {
			await postToHubspot(fields, ip);
			trackProjetoEvent("success_form", {});
			// ⚠ REENVIO LIBERADO: não marcamos mais a conclusão. O progresso é
			// limpo aqui, então reabrir o quiz começa do zero e permite um novo
			// envio do mesmo contato — comportamento pedido (igual ao México).
			clearProgress();
			currentStep = totalSteps + 1;
			showStep(getStepElements().length - 1);

			// Redireciona pra página de gracias. Espera as DUAS coisas:
			//   • o upload dos anexos terminar (navegar antes cancela o POST);
			//   • o tempo mínimo de tela de agradecimento, que também dá folga
			//     pras tags de conversão dispararem.
			const waitUpload = filePromise || Promise.resolve();
			const minDelay = new Promise((r) => window.setTimeout(r, SUCCESS_REDIRECT_DELAY_MS));
			const go = () => goToThankYou(0);
			Promise.all([waitUpload, minDelay]).then(go, go);
		} catch (error) {
			const message = error instanceof Error ? error.message : "Error inesperado al enviar el formulario.";
			console.error("[modal-projeto-ar] Erro no envio:", error);
			window.alert(message);
		} finally {
			isSubmitting = false;
			setSubmitLoading(false);
		}
	}

	// -------------------------------------------------------------------
	// LISTENERS
	// -------------------------------------------------------------------
	backBtn.addEventListener("click", goBack);
	closeBtn.addEventListener("click", () => closeModal(false));
	if (modalSuccessCloseBtn) {
		// Botão "Cerrar" da tela de sucesso: fecha o modal e vai pra página de
		// gracias. Se o redirect da conclusão já está agendado, antecipa; se
		// ainda não está, é porque o upload dos anexos está em andamento —
		// nesse caso não navegamos aqui, pra não cancelar o upload (o fluxo
		// normal navega assim que ele terminar). Não é preciso resetar o form:
		// a navegação descarta o estado da página inteira.
		modalSuccessCloseBtn.addEventListener("click", () => {
			modal.classList.add("hidden");
			document.body.classList.remove("project-start-modal-open");
			if (redirecting) goToThankYou(0, true);
		});
	}

	// Card de confirmação — 3 opções:
	// 1) Primário: só fecha o card, volta pra pergunta.
	// 2) "Saltar esta pregunta": pula SÓ a pergunta atual e segue.
	// 3) "Continuar después": registra a desistência na HubSpot (best-effort)
	//    + salva progresso local + fecha o modal + vai pra página de gracias.
	if (modalConfirmStayBtn) {
		modalConfirmStayBtn.addEventListener("click", () => hideConfirmExit());
	}
	if (modalConfirmSkipBtn) {
		modalConfirmSkipBtn.addEventListener("click", () => skipCurrentStep());
	}
	if (modalConfirmLeaveBtn) {
		modalConfirmLeaveBtn.addEventListener("click", () => {
			// A etapa é lida AQUI, no clique — nunca antes. Assim o valor
			// registrado é sempre a pergunta que estava na tela, e todo clique
			// gera um registro (sem deduplicação por etapa).
			// validateCurrentStep() de propósito NÃO é chamado: quem está saindo
			// não pode ser barrado por campo obrigatório vazio.
			recordExit(EXIT_STEP[currentStep] || "");
			saveProgress();
			hideConfirmExit();
			modal.classList.add("hidden");
			document.body.classList.remove("project-start-modal-open");
			// O POST da desistência vai com keepalive (sobrevive à navegação);
			// os 250 ms são só a folga pra ele entrar na fila de rede antes de
			// o browser começar a navegar.
			if (REDIRECT_ON_EXIT_ENABLED) goToThankYou(250);
		});
	}

	// -------------------------------------------------------------------
	// GATILHOS DE ABERTURA
	// -------------------------------------------------------------------
	// Existem duas formas de abrir o quiz:
	//
	//   1. Atributo [data-project-start-ar-open] — para sections que a gente
	//      controla (ex.: madesa-hero).
	//
	//   2. Um link cuja URL seja "#abrir-quiz" — para sections de TERCEIROS
	//      ou que a gente não quer editar (ex.: "CTA Diseño de Cocina",
	//      blocos de app, rich text, botões de menu). Basta colar #abrir-quiz
	//      no campo de link do botão, pelo editor de tema. Nenhum arquivo
	//      precisa ser alterado — nem agora nem nas próximas vezes.
	//
	// Tudo por delegação no document, então botões renderizados depois
	// (carrossel, paginação, quick add) funcionam sem novo registro.
	const OPEN_HASHES = ["#abrir-quiz", "#quiz-proyectos"];

	/** @param {Element | null} el */
	function isHashTrigger(el) {
		if (!el) return false;
		// getAttribute pega o valor cru ("#abrir-quiz"); .hash pega o fragmento
		// já resolvido, caso o tema transforme em URL absoluta.
		const raw = (el.getAttribute && el.getAttribute("href")) || "";
		const hash = /** @type {HTMLAnchorElement} */ (el).hash || "";
		return OPEN_HASHES.some((h) => hash === h || raw === h || raw.endsWith(h));
	}

	document.addEventListener("click", (e) => {
		if (!(e.target instanceof Element)) return;

		const attrTrigger = e.target.closest("[data-project-start-ar-open]");
		if (attrTrigger) {
			e.preventDefault();
			openModal(getProductIdFromTrigger(attrTrigger));
			return;
		}

		const linkTrigger = e.target.closest("a[href]");
		if (isHashTrigger(linkTrigger)) {
			e.preventDefault();
			openModal(getProductIdFromTrigger(linkTrigger));
			return;
		}

		// Alguns botões de section usam data-scroll-to em vez de href.
		const scrollTrigger = e.target.closest("[data-scroll-to]");
		if (scrollTrigger) {
			const alvo = "#" + (scrollTrigger.getAttribute("data-scroll-to") || "");
			if (OPEN_HASHES.indexOf(alvo) !== -1) {
				e.preventDefault();
				openModal(getProductIdFromTrigger(scrollTrigger));
			}
		}
	});

	modal.addEventListener("click", (e) => {
		// Clicar fora do popup (no overlay) NÃO fecha o modal — de propósito.
		// O usuário só sai pelo X (que passa pela confirmação) ou concluindo.
		if (!(e.target instanceof Element)) return;

		const optionBtn = /** @type {HTMLButtonElement | null} */ (e.target.closest(".option-btn"));
		if (optionBtn && optionBtn.closest(".form-step")) {
			const parent = optionBtn.parentElement;
			const stepElement = /** @type {HTMLElement | null} */ (optionBtn.closest(".form-step"));
			if (parent && stepElement) {
				const stepNum = stepElement.getAttribute("data-step");

				if (stepNum === "5") {
					// Múltipla seleção, até 2 cores.
					if (optionBtn.classList.contains("active")) {
						optionBtn.classList.remove("active");
					} else if (parent.querySelectorAll(".option-btn.active").length < 2) {
						optionBtn.classList.add("active");
					}
					const activeColors = Array.prototype.map.call(
						parent.querySelectorAll(".option-btn.active"),
						(b) => b.getAttribute("data-value") || ""
					);
					formData.color = activeColors.join(",");
					clearOptionGroupError(stepElement);
				} else {
					parent.querySelectorAll(".option-btn").forEach((btn) => btn.classList.remove("active"));
					optionBtn.classList.add("active");

					const value = optionBtn.getAttribute("data-value");
					clearOptionGroupError(stepElement);

					switch (stepNum) {
						case "2":
							formData.format = value;
							formData.formato = value;
							renderStep3ByFormat();
							break;
						case "4":
							formData.line = value;
							updateStep4Buttons();
							break;
						case "6":
							formData.espacioListo = value;
							break;
						case "8":
							formData.presupuesto = value;
							break;
						default:
							break;
					}
				}
			}
		}

		syncNextBtnState(currentStep);

		if (e.target.closest("[data-next-step]")) nextStep();
		if (e.target.closest("[data-submit]")) submitForm();
	});

	// Janela do <input type="month">: do mês atual até 1 ano à frente.
	// min/max PRECISAM estar no formato "YYYY-MM" (não "YYYY-MM-DD").
	const dateInput = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="data-compra"]'));
	if (dateInput) {
		const today = new Date();
		const yyyy = today.getFullYear();
		const mm = String(today.getMonth() + 1).padStart(2, "0");
		dateInput.min = yyyy + "-" + mm;
		dateInput.max = (yyyy + 1) + "-" + mm;

		dateInput.addEventListener("click", () => {
			try { dateInput.showPicker(); } catch (_) {}
		});
		dateInput.addEventListener("focus", () => {
			try { dateInput.showPicker(); } catch (_) {}
		});
		dateInput.addEventListener("change", () => {
			if (!dateInput.value || dateInput.value < dateInput.min || dateInput.value > dateInput.max) {
				showFieldError(dateInput);
			} else {
				clearFieldError(dateInput);
			}
			syncNextBtnState(currentStep);
		});
	}

	modal.addEventListener("change", (e) => {
		if (!(e.target instanceof HTMLInputElement)) return;

		if (e.target.name === "nome") formData.nome = e.target.value;
		if (e.target.name === "email") formData.email = e.target.value;
		if (e.target.name === "telefone") formData.telefone = e.target.value;
		if (/^parede\d+$/.test(e.target.name)) formData[e.target.name] = e.target.value;
		if (e.target.name === "data-compra") formData.data_compra = e.target.value;

		if (e.target.name === "step3_space_file") {
			// ACUMULA entre seleções: o comportamento nativo do <input type="file">
			// é SUBSTITUIR input.files, o que apagaria os anexos anteriores.
			const novos = e.target.files ? Array.prototype.slice.call(e.target.files) : [];
			novos.forEach((f) => {
				const chave = f.name + "|" + f.size + "|" + f.lastModified;
				const jaExiste = uploadedFiles.some((x) => (x.name + "|" + x.size + "|" + x.lastModified) === chave);
				if (!jaExiste) uploadedFiles.push(f);
			});
			syncUploadInput();
			renderUploadStatus();
		}
	});

	modal.addEventListener("input", (e) => {
		if (!(e.target instanceof HTMLInputElement)) return;

		if (e.target.name === "telefone") {
			e.target.value = formatArgentinaPhone(e.target.value);
			formData.telefone = e.target.value;
			syncNextBtnState(currentStep);
		}

		if (e.target.name === "email" || e.target.name === "nome" || /^parede\d+$/.test(e.target.name) || e.target.name === "data-compra") {
			clearFieldError(e.target);
			if (e.target.name === "email" || e.target.name === "nome") {
				syncNextBtnState(currentStep);
			}
			if (/^parede\d+$/.test(e.target.name)) {
				updateStep3Buttons();
			}
		}
	});

	// Remover anexo. Delegação de evento porque a lista é re-renderizada a cada
	// mudança — listeners individuais se perderiam. Registrado UMA vez aqui.
	modal.addEventListener("click", (e) => {
		if (!(e.target instanceof Element)) return;
		const removeBtn = e.target.closest("[data-upload-remove]");
		if (!removeBtn) return;
		e.preventDefault();
		e.stopPropagation();
		const index = Number(removeBtn.getAttribute("data-upload-remove"));
		if (!Number.isNaN(index)) removeUploadFile(index);
	});

	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape" && !modal.classList.contains("hidden")) {
			closeModal(false);
		}
	});

	// Fechar a aba / navegar pra outra página no meio do quiz também preserva o
	// progresso. Só grava localmente (nada de POST aqui: requisição disparada em
	// pagehide é abortada pelo navegador na maioria dos casos).
	window.addEventListener("pagehide", () => {
		if (currentStep >= 1 && currentStep <= totalSteps) saveProgress();
	});
})();